import { render, staticRenderFns } from "./DetailsCarDescription.vue?vue&type=template&id=3caeb8f4&scoped=true&"
import script from "./DetailsCarDescription.vue?vue&type=script&lang=js&"
export * from "./DetailsCarDescription.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCarDescription.vue?vue&type=style&index=0&id=3caeb8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caeb8f4",
  null
  
)

export default component.exports